export enum TableCellVerticalAlignment {
  top,
  middle,
  bottom,
  baseline,
  fill,
}
